// "Kürzlich angesehen" – rein clientseitig über localStorage, da Shopify
// dafür keine eingebaute Datenquelle bietet. Merkt sich die zuletzt
// besuchten Produkt-Handles und rendert die (bis zu 6) Produkte davor.
//
// Die Karten sind die ECHTEN nativen Horizon-Produktkarten (Bild-Hover-
// Wechsel, Quick-Add), geholt per Section-Rendering-API von der versteckten
// Hilfssektion "ds-recently-card" (sections/ds-recently-card.liquid).
//
// Die Karussell-Hülle (slideshow-component + Pfeile) kommt fertig
// server-gerendert aus snippets/ds-recently-viewed.liquid - identisches
// natives Markup wie "Andere Kund:innen kauften auch". Dieses Skript füllt
// nur die Slides hinein und re-initialisiert die Komponente per
// Clone-Replace, damit ihr connectedCallback alle Slides/Refs vorfindet.

// Oeffentliche Mini-API (window.dsRecentlyViewed): Verlauf lesen und
// einzelne native Karten holen — genutzt vom Bundle-Picker "Weiteres
// Design hinzufuegen" (ds-pdp-bundle.js), damit dort exakt dieselben
// Karten erscheinen wie in "Kuerzlich angesehen".

(() => {
  if (window.dsRecentlyViewed) return;
  const STORAGE_KEY = 'ds_recently_viewed';
  const MAX_STORED = 12;
  const MAX_SHOWN_DEFAULT = 6;

  function readHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage nicht verfügbar (z.B. privater Modus) – einfach überspringen */
    }
  }

  function getRecentlyCardSectionId() {
    const el = document.querySelector('[id$="__ds_recently_card"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  // Markt-Praefix (window.DS_MARKET.root), damit die Karte die Preise des
  // aktiven Markts zeigt.
  const ROOT = (window.DS_MARKET && window.DS_MARKET.root) || '';

  async function fetchCard(handle, sectionId) {
    try {
      const res = await fetch(ROOT + '/products/' + handle + '?section_id=' + sectionId);
      if (!res.ok) return null;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector('.ds-recently-card-source product-card');
      if (!source) return null;
      const item = document.createElement('div');
      item.className = 'resource-list__item';
      item.appendChild(source);
      return item;
    } catch (e) {
      return null;
    }
  }

  async function init(root) {
    if (root.dataset.dsRvInit) return;
    root.dataset.dsRvInit = '1';

    const currentHandle = root.dataset.currentHandle;
    const maxShown = parseInt(root.dataset.maxShown, 10) || MAX_SHOWN_DEFAULT;
    const isCarousel = root.dataset.layout !== 'grid';
    const history = readHistory();

    const toShow = history.filter((h) => h !== currentHandle).slice(0, maxShown);

    const updatedHistory = [currentHandle, ...history.filter((h) => h !== currentHandle)];
    writeHistory(updatedHistory);

    if (toShow.length < 1) return;

    const sectionId = getRecentlyCardSectionId();
    if (!sectionId) return;

    try {
      const cards = await Promise.all(toShow.map((handle) => fetchCard(handle, sectionId)));
      const validCards = cards.filter(Boolean);
      if (validCards.length < 1) return;

      const row = root.querySelector('[data-ds-recently-viewed-row]');

      if (isCarousel) {
        // Karussell: echte native slideshow-slides + Re-Init der Komponente.
        const component = root.querySelector('[data-ds-recently-shell]');
        const timeline = validCards.map((_, i) => '--slide-' + i).join(',');
        component.style.setProperty('--slideshow-timeline', timeline);
        validCards.forEach((card, i) => {
          const slide = document.createElement('slideshow-slide');
          slide.setAttribute('ref', 'slides[]');
          slide.className = 'resource-list__slide';
          slide.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
          slide.style.cssText = '--slideshow-timeline: --slide-' + i + ';';
          slide.appendChild(card);
          row.appendChild(slide);
        });
        // Erst sichtbar machen, dann re-initialisieren: connectedCallback der
        // Komponente misst Slide-Positionen - im versteckten Zustand wären
        // alle Masse 0.
        root.hidden = false;
        component.replaceWith(component.cloneNode(true));
      } else {
        // Raster: die Karten (bereits als resource-list__item verpackt) direkt
        // ins Grid haengen - kein Slideshow-Wrapper, kein Re-Init noetig.
        validCards.forEach((card) => row.appendChild(card));
        root.hidden = false;
      }
    } catch (e) {
      /* Netzwerkfehler – Sektion bleibt einfach ausgeblendet */
    }
  }

  window.dsRecentlyViewed = {
    readHistory,
    getSectionId: getRecentlyCardSectionId,
    fetchCard: (handle) => {
      const id = getRecentlyCardSectionId();
      return id ? fetchCard(handle, id) : Promise.resolve(null);
    },
  };

  function ready() {
    document.querySelectorAll('[data-ds-recently-viewed]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
